/**
 * ساخت لینک عمومی و لینک دعوت هر پرسشنامه.
 *
 * لینک‌ها با پیامک فرستاده می‌شوند و هر ۷۰ کاراکتر فارسی یک بخش هزینه دارد،
 * پس برای پرسشنامه‌های پرمصرف یک مسیر کوتاه در فرانت تعریف شده است.
 * برای پرسشنامه‌ای که مسیر کوتاه ندارد، `/assessment?s=<slug>` استفاده می‌شود
 * که همیشه کار می‌کند.
 *
 * ⚠️ افزودن مسیر کوتاه جدید یعنی یک Route هم در frontend/src/App.tsx لازم است.
 */

/** آدرس سایت عمومی؛ پنل ادمین روی ساب‌دامین جداست پس origin به کار نمی‌آید */
export const SITE_ORIGIN =
  process.env.REACT_APP_SITE_URL?.replace(/\/$/, '') || 'https://manehaghighi.com';

const SHORT_PATHS: Record<string, string> = {
  /** پرسشنامهٔ مسیر رشد (اولویت‌بندی دوره‌ها) */
  'porseshname-shefaye-zakhm': '/roshd',
  /** تست سحر روانی (قیف ورودی کارگاه شفای زخم) */
  sehr: '/sehr',
};

/** مسیر نسبی پرسشنامه (بدون origin)، همراه با query در صورت نیاز */
export function assessmentPath(slug: string, params?: Record<string, string | undefined>): string {
  const short = SHORT_PATHS[slug];
  const search = new URLSearchParams();
  if (!short) search.set('s', slug);
  for (const [key, value] of Object.entries(params ?? {})) {
    if (value) search.set(key, value);
  }
  const query = search.toString();
  return `${short || '/assessment'}${query ? `?${query}` : ''}`;
}

export const publicLink = (slug: string) => `${SITE_ORIGIN}${assessmentPath(slug)}`;

/** لینک دعوت: `i` کد دعوت و `w` کارگاه پیش‌انتخاب‌شده */
export const inviteLink = (slug: string, code: string, workshopSlug?: string | null) =>
  `${SITE_ORIGIN}${assessmentPath(slug, { w: workshopSlug ?? undefined, i: code })}`;

/** همان لینک بدون //:https — گوشی خودش لینکش می‌کند و ۸ کاراکتر کمتر می‌شود */
export const smsLink = (link: string) => link.replace(/^https?:\/\//, '');
